import {
  getFontCss,
  styleConstants,
  Tag,
  TagColorSchemes,
  TagSizes,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import ActiveUntilTooltip from 'src/components/ActiveUntilTooltip/ActiveUntilTooltip'
import Header from 'src/components/Header/Header'
import SvgShowHoverFilled from 'src/components/Svgs/SvgShowHoverFilled'
import { BudgetTypes } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { CreditCardListModel } from 'src/models/creditCard.models'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface AccountHeaderProps {
  className?: string
  creditCard: CreditCardListModel
}

const AccountHeader: React.FC<AccountHeaderProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const userId = useSelector(selectUserIdFromState)
  const accountClosed = props.creditCard.isClosed

  const budgetTagText = props.creditCard.recurrence
    ? BudgetTypes.recurring
    : !props.creditCard.isLimitedBudget
      ? BudgetTypes.unlimited
      : BudgetTypes.standard

  return (
    <Header>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: left;
        `}
        data-testid="account-header"
      >
        <div
          css={css`
            display: flex;
            align-items: center;
          `}
        >
          {!props.creditCard.isBudget && (
            <img
              css={css`
                height: 30px;
                border-radius: 3.37%/5.92%;
                margin-right: 20px;
              `}
              src={props.creditCard.cardImage.urls.medium}
              alt={''}
            />
          )}
          <div
            css={css`
              display: flex;
              overflow: hidden;
              align-items: flex-end;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  40,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )}
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              `}
              data-testid="account-name"
            >
              {props.creditCard.truncatedDisplayName}
            </span>
            {!props.creditCard.isBudget &&
              !props.creditCard.partner?.isVirtualAccount && (
                <span
                  css={css`
                    ${getFontCss(
                      12,
                      styleConstants.colors.gray_darkest,
                      styleConstants.fontFamilies.regular,
                    )}
                    margin-bottom: 8px;
                    margin-left: 10px;
                  `}
                >
                  {props.creditCard.user.id === userId ? (
                    <Tag text={props.creditCard.last4} size={TagSizes.Medium} />
                  ) : (
                    <Tag
                      text={props.creditCard.last4}
                      color={TagColorSchemes.Green}
                      size={TagSizes.Medium}
                      icon={
                        <SvgShowHoverFilled
                          style={{
                            transform: 'scale(0.7)',
                            marginTop: '-6px',
                          }}
                        />
                      }
                    />
                  )}
                </span>
              )}
            {props.creditCard.isBudget && (
              <span
                css={css`
                  ${getFontCss(
                    12,
                    styleConstants.colors.gray_darkest,
                    styleConstants.fontFamilies.regular,
                  )}
                  margin-bottom: 8px;
                  margin-left: 10px;
                `}
              >
                <Tag text={translate(budgetTagText)} size={TagSizes.Medium} />
              </span>
            )}
          </div>
        </div>
        {!props.creditCard.isBudget && accountClosed && (
          <div
            css={css`
              display: flex;
              align-items: center;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  40,
                  styleConstants.colors.red,
                  styleConstants.fontFamilies.regular,
                )}
              `}
            >
              {translate('Closed')}
            </span>
            <ActiveUntilTooltip openLeft={false} isAccountClosed />
          </div>
        )}
      </div>
    </Header>
  )
}

export default AccountHeader
